import axios from 'axios';

class UploadFileService {
    upload(file, id, file_type, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);       
        formData.append('id', id);
        formData.append('file_type', file_type);

        return axios.post("/api/store-file", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress
        });
    }

    getFiles($student_id) {
        return axios.get("/api/get-files/"+$student_id)
    }

    deleteFile(id, file_name, file_type) {
        const url = '/api/file';
        return axios.delete(url, {
            params: {
                id: id,
                fileName: file_name,
                fileType: file_type
            }
        })
    }
}

export default new UploadFileService();